/**
 * config.js — Change the API base URL here when your backend changes.
 */

export const API_BASE_URL = 'https://api.afri-bet.org';

